import apiClient from '../client'
import type { OfficeReviewStatus, OfficeReviewStatusAdmin, OfficeReviewStatusUpsert } from './types'

const mgmtBase = (municipalityId: number) => `/api/municipalities/${municipalityId}/office-review-statuses`

export const officeReviewStatusesApi = {
  /** ログインユーザーの自治体スコープの有効ステータス候補を表示順で取得する。 */
  list() {
    return apiClient.get<OfficeReviewStatus[]>('/api/office-review-statuses', {
      _silent: true,
    })
  },

  /** 自治体管理: 指定自治体の全候補（無効含む）を表示順で取得する（管理No.25）。 */
  listForManagement(municipalityId: number) {
    return apiClient.get<OfficeReviewStatusAdmin[]>(mgmtBase(municipalityId))
  },

  /** 自治体管理: 候補を追加する（code/並び順はサーバ採番）。 */
  create(municipalityId: number, body: OfficeReviewStatusUpsert) {
    return apiClient.post<OfficeReviewStatusAdmin>(mgmtBase(municipalityId), body, { _silent: true })
  },

  /** 自治体管理: 候補を更新する（表示名・色・並び順・有効無効）。 */
  update(municipalityId: number, id: number, body: OfficeReviewStatusUpsert) {
    return apiClient.put<OfficeReviewStatusAdmin>(`${mgmtBase(municipalityId)}/${id}`, body, { _silent: true })
  },

  /** 自治体管理: 候補を無効化する（is_active=false。recipients が参照するため物理削除しない）。 */
  deactivate(municipalityId: number, id: number) {
    return apiClient.delete<void>(`${mgmtBase(municipalityId)}/${id}`)
  },

  // ── ログインユーザー自治体スコープ版（独立管理画面 /admin/office-review-statuses 用。管理No.25）──
  // 自治体はサーバが requireMunicipalityScope() でログインユーザーから導出する（パスに持たない）。

  /** 自分の自治体の全候補（無効含む）を表示順で取得する。 */
  listForMyMunicipality() {
    return apiClient.get<OfficeReviewStatusAdmin[]>('/api/admin/office-review-statuses')
  },

  /** 自分の自治体に候補を追加する。 */
  createForMyMunicipality(body: OfficeReviewStatusUpsert) {
    return apiClient.post<OfficeReviewStatusAdmin>('/api/admin/office-review-statuses', body, { _silent: true })
  },

  /** 自分の自治体の候補を更新する。 */
  updateForMyMunicipality(id: number, body: OfficeReviewStatusUpsert) {
    return apiClient.put<OfficeReviewStatusAdmin>(`/api/admin/office-review-statuses/${id}`, body, { _silent: true })
  },

  /** 自分の自治体の候補を無効化する。 */
  deactivateForMyMunicipality(id: number) {
    return apiClient.delete<void>(`/api/admin/office-review-statuses/${id}`)
  },
}
